import axios from 'axios'
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil'
import {URL} from '../../util/ambienteActions';
import {ALTERAR_PRESTADOR_ITINERARIOS_EM_LOTE} from '../types';

export function alterarPrestadorItinerarioEmLote(parametros) {
    const url = `${URL}/itinerario/alterar-prestador-itinerarios-em-lote`;
    return dispatch => axios.post(url, parametros, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: ALTERAR_PRESTADOR_ITINERARIOS_EM_LOTE,
            payload: response
        })
    );
}
